export const DEACTIVATED_FOLDERS_QUERY_KEY = [
  "deactivatedFoldersForFolderAdmin",
];

export const INVITABLE_GROUPS_QUERY_KEY = ["invitableGroupsForFolderAdmin"];
